// import { getField, updateField } from 'vuex-map-fields'

export default {
  state: {
    shopCode: null,
    productionMode: ''
  },
  actions: {
    getShopCode (context) {
      context.commit('setShopByUrl')
    },
    getProductionMode (context, {shopCode}) {
      context.commit('setProductionMode', {shopCode})
    }
  },
  mutations: {
    setShopByUrl (state) {
      document.body.dataset.url = location.href
      console.log('{common} [setShopByUrl] ' + Date.now() + ' document.body.dataset.url=' + document.body.dataset.url)
      let shopCode = null
      if (document.body.dataset.url.includes('/shop2/')) {
        shopCode = 'shop2'
      } else {
        shopCode = null
      }
      state.shopCode = shopCode
      console.log('{common} state.shopCode=' + state.shopCode)
    },
    setProductionMode (state, {shopCode}) {
      console.log('common [setProductionMode] ' + Date.now() + ' shopCode=' + shopCode)
      let productionMode = ''
      if (shopCode === 'shop2') {
        productionMode = 'F'
      } else {
        productionMode = 'E'
      }
      state.productionMode = productionMode
      console.log('state.productionMode=' + state.productionMode)
    }
    // updateField
  }
  // computed
  /*
  getters: {
    getField
  }
  */
}



// WEBPACK FOOTER //
// ./src/store/modules/commonShop.js